<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>انقال وجه از حساب</span> <span v-if="selectedAccount" class="text-bold"> {{
          selectedAccount.accountNumber
        }} </span>
        <template v-slot:action>
          <q-chip color="green" text-color="white" icon-right="attach_money">
            <span v-if="!$q.screen.lt.md">موجودی حساب</span> <span
              class="q-ml-xs text-bold">{{ accountBalance.toLocaleString() }}</span>
            <q-tooltip v-if="!$q.screen.lt.md">
              موجودی حساب
            </q-tooltip>
          </q-chip>
          <q-btn icon="close" round flat v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-card-section>
        <q-field
            v-model="distinationInfo.money"
            mask="currency"
            label-color="indigo"
            autofocus
            dir="ltr"
            filled
            label="مبلغ انتقال"
            clearable
            lazy-rules
            :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value.replaceAll(',',''))"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-banner rounded v-if="distinationInfo.shabaVerify" class="s bg-indigo text-white">
          <span>انتقال وجه به حساب </span><span class="text-bold">{{distinationInfo.name}}</span> <span>انجام خواهد شد</span>
        </q-banner>
      </q-card-section>
      <q-card-section>
        <q-card bordered class="shadow-5">
          <q-card-section class="no-padding">
            <q-banner class="bg-indigo text-white" dense inline-actions>
              <span>انتقال وجه داخلی، پایا،‌ساتنا</span>
            </q-banner>
          </q-card-section>
          <q-card-section class="no-padding">
            <q-input dir="ltr" v-model="distinationInfo.shaba"
                     :dense="$q.screen.lt.md"
                     aria-autocomplete="none"
                     label="شماره شبا"
                     fill-mask
                     unmasked-value
                     mask="IR (##) (###) (#) (####) (####) (####) (####) (##)"
                     filled>
              <template v-slot:append>
                <q-icon name="check" v-if="distinationInfo.shabaVerify" round color="green">
                </q-icon>
                <q-btn v-if="!distinationInfo.shabaVerify"
                       :size="!$q.screen.lt.md?'md':'sm'"
                       @click="getAccountInfo(true)"
                       label="بررسی" color="indigo" text-color="white"/>
                <q-btn v-if="distinationInfo.shabaVerify"
                       :disable="distinationInfo.money<=0"
                       label="پرداخت" color="indigo" text-color="white" />
              </template>
            </q-input>
          </q-card-section>
        </q-card>
      </q-card-section>
    </q-card-section>
    <q-card-section class="no-padding q-mt-lg">
      <q-card-section>
        <q-card bordered class="shadow-5">
          <q-card-section class="no-padding">
            <q-banner class="bg-indigo text-white" dense inline-actions>
              <span>انتقال وجه پل</span>
            </q-banner>
          </q-card-section>
          <q-card-section class="no-padding">
            <q-input dir="ltr" v-model="distinationInfo.shaba"
                     :dense="$q.screen.lt.md"
                     aria-autocomplete="none"
                     label="شماره شبا"
                     fill-mask
                     unmasked-value
                     mask="IR (##) (###) (#) (####) (####) (####) (####) (##)"
                     filled>
              <template v-slot:append>
                <q-icon name="check" v-if="distinationInfo.shabaVerify" round color="green" />
                <q-btn
                    :dense="$q.screen.lt.md"
                    v-if="!distinationInfo.shabaVerify"
                    @click="getAccountInfo(true)"
                    :size="!$q.screen.lt.md?'md':'sm'"
                    label="بررسی" color="indigo" text-color="white"/>
                <q-btn v-if="distinationInfo.shabaVerify"
                       :disable="distinationInfo.money<=0"
                       label="پرداخت" color="indigo" text-color="white" />
              </template>
            </q-input>
          </q-card-section>
        </q-card>
      </q-card-section>
    </q-card-section>
    <q-card-section class="no-padding q-mt-lg">
      <q-card-section>
        <q-card bordered class="shadow-5">
          <q-card-section class="no-padding">
            <q-banner class="bg-indigo text-white" dense inline-actions>
              <span>انتقال کارت به کارت</span>
            </q-banner>
          </q-card-section>
          <q-card-section class="no-padding">
            <q-input dir="ltr" v-model="distinationInfo.cardNumber"
                     :dense="$q.screen.lt.md"
                     aria-autocomplete="none"
                     label="شماره کارت بانکی"
                     fill-mask
                     unmasked-value
                     mask="(####) (####) (####) (####)"
                     filled>
              <template v-slot:append>
                <q-icon name="check" v-if="distinationInfo.cardVerify" round color="green">
                </q-icon>
                <q-btn
                    :dense="$q.screen.lt.md"
                    v-if="!distinationInfo.cardVerify"
                    :size="!$q.screen.lt.md?'md':'sm'"
                    @click="getAccountInfo(false)"
                    label="بررسی" color="indigo" text-color="white"/>
                <q-btn v-if="distinationInfo.cardVerify"
                       :disable="distinationInfo.money<=0"
                       label="پرداخت" color="indigo" text-color="white" />
              </template>
            </q-input>
          </q-card-section>
        </q-card>
      </q-card-section>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "TransferMoney",
  props: {
    selectedAccount: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    accountBalance: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {
      distinationInfo: {
        shaba: undefined,
        shabaVerify: false,
        cardNumber:undefined,
        money:0,
        name: undefined,
        cardVerify:undefined
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods:{
    ...mapActions({
      getCardInfo: 'Finnotech/getCardInfo',
      getIbanInfo: 'Finnotech/getIbanInfo',
    }),
    getAccountInfo(shaba) {
      if (shaba) {
        if (this.distinationInfo.shaba===undefined) return;
        this.getIbanInfo(`IR${this.distinationInfo.shaba}`).then((res) => {
          this.distinationInfo.name = res.data.depositOwners[0].firstName + ' ' + res.data.depositOwners[0].lastName
          this.distinationInfo.shabaVerify = true
        })
      } else {
        if (this.distinationInfo.cardNumber===undefined) return;
        this.getCardInfo(this.distinationInfo.cardNumber).then((res) => {
          this.distinationInfo.name = res.data.name
        })
      }
    },
  }
}
</script>
<style scoped>

</style>